/**
 * Konfiguracja captchy (Cloudflare Turnstile) dla formularzy auth.
 *
 * Realne blokowanie botów dzieje się po stronie Supabase (Auth → Attack
 * Protection), które weryfikuje token u Cloudflare sekretem niedostępnym
 * dla klienta. Widget na froncie tylko dostarcza ten token prawdziwym
 * użytkownikom.
 *
 * Brak VITE_TURNSTILE_SITE_KEY = captcha wyłączona (lokalny dev, testy).
 * Wymuszanie w Supabase i klucz na froncie muszą być włączane razem.
 */

export function getTurnstileSiteKey(): string {
  const raw = import.meta.env.VITE_TURNSTILE_SITE_KEY
  return typeof raw === 'string' ? raw.trim() : ''
}

export function isCaptchaEnabled(): boolean {
  return getTurnstileSiteKey().length > 0
}

/** Czy formularz może zostać wysłany przy obecnym stanie captchy. */
export function isCaptchaSatisfied(token: string | null): boolean {
  return !isCaptchaEnabled() || Boolean(token)
}
